import { render, staticRenderFns } from "./Regiones.vue?vue&type=template&id=2da06536&scoped=true"
import script from "./Regiones.vue?vue&type=script&lang=js"
export * from "./Regiones.vue?vue&type=script&lang=js"
import style0 from "./Regiones.vue?vue&type=style&index=0&id=2da06536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da06536",
  null
  
)

export default component.exports